import React, { FC } from 'react';
import './index.scss';
import { StaticImage } from 'gatsby-plugin-image';
import { graphql, useStaticQuery } from 'gatsby';

const AboutUs = React.forwardRef<HTMLDivElement, {}>(function AboutUs({}, ref) {
  return (
    <section id='about' key='about-us-section' ref={ref}>
      <div className='about-us-container'>
        <div className='about-us-image'>
          <StaticImage
            src='../../images/one-fam-store-front.jpg'
            alt='ONEFAM Counter'
            placeholder='none'
            style={{
              gridArea: '1/1',
            }}
            layout='fullWidth'
          />
        </div>
        <div className='about-us-text'>
          <div className='about-us-content'>
            <h2 className='about-us-title'>
              <span
                data-sal='slide-up'
                data-sal-duration='500'
                data-sal-easing='ease-in-out'
              >
                About
              </span>
              <br />
              <span
                data-sal='slide-up'
                data-sal-duration='500'
                data-sal-delay='200'
                data-sal-easing='ease-in-out'
              >
                ONEFAM
              </span>
            </h2>
            <p
              className='about-us-description'
              data-sal='slide-up'
              data-sal-duration='500'
              data-sal-easing='ease-in-out'
            >
              a family cultured atmosphere committed to providing each client
              the utmost care by tailoring to your hair needs. we are
              professional artists without boundaries continuing to grow by
              sharpening our technical skills and creatively learning new styles
              in the game. our ultimate focus is to build a foundation with the
              community, to give back and to support future professional
              artists.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
});

export default AboutUs;
